"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudienceSelectList = void 0;
var _AudienceSelectList = require("./AudienceSelectList.styles");
var _AudienceList = require("./partials/AudienceList");
var _jsxRuntime = require("react/jsx-runtime");
const AudienceSelectList = props => {
  const {
    audienceType,
    classesIds = [],
    selectedClassesIds = [],
    readOnlyGroupsMapper,
    classesMapper = null,
    groupsIds = [],
    selectedGroupsIds = [],
    groupsMapper = null,
    studentsIds = [],
    selectedStudentsIds = [],
    readOnlyStudentsMapper,
    studentsMapper = null
  } = props;
  const styles = (0, _AudienceSelectList.useStyles)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__audience-select-list'],
    children: [audienceType === 'classes' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceList.AudienceList, {
      ...props,
      audienceIds: classesIds,
      selectedAudienceIds: selectedClassesIds,
      readOnlyMapper: readOnlyGroupsMapper,
      mapper: classesMapper,
      audienceType: "classes"
    }), audienceType === 'groups' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceList.AudienceList, {
      ...props,
      audienceIds: groupsIds,
      selectedAudienceIds: selectedGroupsIds,
      readOnlyMapper: readOnlyGroupsMapper,
      mapper: groupsMapper,
      audienceType: "groups"
    }), audienceType === 'students' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudienceList.AudienceList, {
      ...props,
      audienceIds: studentsIds,
      selectedAudienceIds: selectedStudentsIds,
      readOnlyMapper: readOnlyStudentsMapper,
      mapper: studentsMapper,
      audienceType: "students"
    })]
  });
};
exports.AudienceSelectList = AudienceSelectList;